import * as BusEvents from "@/constants/bus-events";
import * as Mutations from "@/store/constants/mutations";
import store from "@/store/index";
import AuthUtils from "@/utils/auth";
import AxiosUtils from "@/utils/axios-utils";
import SessionUtils from "@/utils/session";
import axios from "axios";
import { Notification } from "element-ui";
import _ from "lodash";

window.axios = require("axios");
window.axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
};
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token",
    );
}

// Add new constant for custom error types
const ERROR_TYPES = {
    SHIPPING: 'shipping_error',
    VALIDATION: 'validation_error',
    AUTH: 'auth_error',
    SERVER: 'server_error',
    RATE_LIMIT: 'rate_limit',
    BUSINESS: 'business_error'
};

window.axios.interceptors.response.use(
    function (response) {
        SessionUtils.updateLastActive();
        return response;
    },
    function (error) {
        console.log("axios", error);
        let status = _.get(error, "response.status");
        let errorType = _.get(error, "response.data.error_type");
        let message = _.get(error, "response.data.error_message") || 
                     _.get(error, "response.data.message");
        let errors = _.get(error, "response.data.errors");
        let errorCode = _.get(error, "response.data.error");

        // Update session if user is logged in
        if (AuthUtils.loggedIn() && ![401].includes(status)) {
            SessionUtils.updateLastActive();
        }

        // Handle specific business error types
        if (errorType) {
            switch (errorType) {
                case ERROR_TYPES.SHIPPING:
                    Notification.warning({
                        title: "Shipping Calculator",
                        message: message || "Unable to calculate shipping. Please verify your address.",
                        duration: 5000
                    });
                    break;
                    
                case ERROR_TYPES.BUSINESS:
                    Notification.warning({
                        title: "Action Required",
                        message: message,
                        duration: 5000
                    });
                    break;
                    
                default:
                    // Handle other custom error types
                    break;
            }
            return Promise.reject(error);
        }

        // Handle HTTP status codes
        switch (status) {
            case 400:
                Notification.error({
                    title: "Invalid Request",
                    message: getFriendlyErrorMessage(message, "Please check your input and try again."),
                    duration: 5000
                });
                break;

            case 403:
                if (errorCode) {
                    window.Bus.$emit(`error:${errorCode}`);
                }
                Notification.error({
                    title: "Access Denied",
                    message: getFriendlyErrorMessage(message, "You don't have permission to perform this action."),
                    duration: 5000
                });
                break;

            case 422:
                handleValidationErrors(errors, message);
                break;

            case 429:
                Notification.warning({
                    title: "Slow Down",
                    message: "You're doing that too often. Please wait a moment and try again.",
                    duration: 5000
                });
                break;

            case 500:
                Notification.error({
                    title: "System Error",
                    message: `We're sorry, something went wrong. If this continues, please contact support at <a href="mailto:support@corwindesign.com">support@corwindesign.com</a>`,
                    duration: 0,
                    dangerouslyUseHTMLString: true
                });
                break;

            case 419:
                return AxiosUtils.refreshTokens().then((token) => {
                    error.config.headers["X-CSRF-TOKEN"] = token;
                    store.commit(Mutations.SET_CSRF, token);
                    return axios.request(error.config);
                });

            case 401:
                window.Bus.$emit(BusEvents.ERROR_UNAUTHENTICATED);
                break;
        }

        return Promise.reject(error);
    }
);

// Helper functions
function getFriendlyErrorMessage(message, defaultMessage) {
    return message || defaultMessage;
}

function handleValidationErrors(errors, message) {
    if (!errors) {
        Notification.warning({
            title: "Validation Error",
            message: message || "Please check your input and try again.",
            duration: 5000
        });
        return;
    }

    const errorMessages = Object.values(errors)
        .filter(val => val)
        .map(val => `<li>${val}</li>`)
        .join('');

    if (errorMessages) {
        Notification.warning({
            title: message || "Please Fix the Following:",
            message: `<ul style="list-style-type: none; padding-left: 0;">${errorMessages}</ul>`,
            duration: 8000,
            dangerouslyUseHTMLString: true
        });
    }
}
